import { useBooleanState } from '@cian/react-utils';

import { FC } from 'react';

import { useIntersectionObserver } from 'shared/hooks/useIntersectionObserver';

type RenderInViewPortProps = {
  children(): JSX.Element | null;
};

export const RenderInViewPort: FC<RenderInViewPortProps> = props => {
  const { children } = props;

  const { state: wasShown, setTrue: setWasShown } = useBooleanState();

  const { elementRef } = useIntersectionObserver<HTMLDivElement>({
    deps: [],
    onInViewport({ observer }) {
      observer.disconnect();

      setWasShown();
    },
  });

  return wasShown ? children() : <div ref={elementRef} />;
};
